import React, { useEffect, useState } from "react";

import api from "../../../../configs/api";
import Loader from "../../../../common/Loader";

import Swal from "sweetalert2";
import { Alert } from "@mui/material";
import DropdownLinksAdmin from "../../../../utils/DropdownLinksAdmin";
import CustomPagination from "../../../ui/Pagination";

export default function Table({
  handleModal,
  setIsEdit,
  setIsDelete,
  rows,
  itemsPerPage,
  setIdUserForDelete,
  status,
  setStatus,
  setInfoForUpdate,
  url
}) {
  const [loading, setLoading] = useState(false);

  const [totalItems, setTotalItems] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);

  const [services, setServices] = useState([]);

  const handleNextPage = (event, value) => {
    setCurrentPage(value);
  };

  const handleDelete = (id) => {
    handleModal(setIsDelete, true);
    setIdUserForDelete(id);
  };

  function handleEdit(user) {
    setInfoForUpdate(user);
    handleModal(setIsEdit, true);
  }

  async function getServices(page) {
    setLoading(true);

    try {
      const res = await api.get(
        `${url}?page=${page}&pageSize=${itemsPerPage}`,
      );
      setServices(res.data.servicesData);
      setTotalItems(res.data.totalPages);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching data:", error);
      setLoading(false);
    }
  }

  useEffect(() => {
    getServices(currentPage);
  }, [currentPage]);

  useEffect(() => {
    if (status.show) {
      Swal.fire({
        position: "center",
        icon: status.icon,
        title: status.title,
        showConfirmButton: status.showConfirmButton,
        timer: status.timer,
      });
      getServices(currentPage);
    }
    setStatus(false);
  }, [status]);

  if (loading) {
    return <Loader />;
  }

  return (
    <div>
      <div className='flex flex-col rounded-lg'>
        <div className='overflow-x-auto'>
          <div className='inline-block min-w-full align-middle'>
            <div className='overflow-hidden shadow'>
              <h1 className='bg-[#f5f5f5] p-4 text-xl'>Services List</h1>
              {services.length <= 0 && (
                <Alert severity='info'>There are no Services!</Alert>
              )}
              <table className='min-w-full divide-y divide-gray-200 table-fixed dark:divide-gray-600'>
                <thead className='bg-white dark:bg-gray-700'>
                  <tr>
                    {rows?.map((row) => {
                      return (
                        <th
                          key={row}
                          scope='col'
                          className='p-4 text-xs font-medium text-left  uppercase text-primary'
                        >
                          {row}
                        </th>
                      );
                    })}
                  </tr>
                </thead>
                <tbody className='bg-white divide-y divide-gray-200 dark:bg-gray-800 dark:divide-gray-700'>
                  {services?.map((row) => {
                    return (
                      <tr className='hover:bg-gray-100 dark:hover:bg-gray-700'>
                        <td key={row?._id} className='flex items-center p-3 space-x-6 whitespace-nowrap'>
                          <img
                            alt='img'
                            className='w-10 h-10 rounded-full'
                            src={row?.image || "global_Images/user.png"}
                          />
                          <div className='text-sm font-normal text-gray-500 dark:text-gray-400'>
                            <div className='text-base font-semibold text-gray-900 dark:text-white'>
                              {row?.title}
                            </div>
                          </div>
                        </td>
                        <td>
                          <DropdownLinksAdmin
                            valueEdit={row}
                            functionEdit={handleEdit}
                            valueDelete={row?._id}
                            functionDelete={handleDelete}
                          />
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <CustomPagination
          totalItems={totalItems}
          currentPage={currentPage}
          handleNextPage={handleNextPage}
        />
      </div>
    </div>
  );
}
